import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import { IApplicationState, createRootReducer } from './store';

const configureStore = (startingState: IApplicationState) => {
  // create the composing function for middlewares
  const composeEnhancers = composeWithDevTools({});

  const store = createStore(
    createRootReducer(),
    startingState,
    composeEnhancers(applyMiddleware()),
  );

  return store;
};

export default configureStore;
